export default class ShopMenuButton extends HTMLElement {
    open: boolean = false
    btnEl: HTMLElement | null = null

    static get observedAttributes() {
        return ['open']
    }

    constructor() {
        super()

        this.btnEl = this.querySelector<HTMLElement>('button[data-menu-button]') as HTMLElement
        ;(window as any).addEventListener('menu:toggle', this.handleMenu.bind(this))
        this.btnEl.addEventListener('click', this.handleClick.bind(this))
    }

    get isOpen() {
        return this.open
    }

    set isOpen(value: boolean) {
        this.open = value
        this.setAttribute('open', value.toString())
        this.toggle()
    }

    handleMenu(evt: CustomEvent) {
        // @ts-ignore
        this.isOpen = evt.detail.open
    }

    handleClick(evt: Event) {
        evt.preventDefault()

        window.dispatchEvent(new CustomEvent('menu:toggle', { bubbles: true, detail: { open: !this.isOpen } }))
    }

    toggle() {
        if (this.isOpen) {
            this.btnEl?.classList.add('right-0')
        } else {
            this.btnEl?.classList.remove('right-0')
        }
    }
}

customElements.define('shop-menu-button', ShopMenuButton)
